export default "__VITE_ASSET__BgRMr5aT__"